import {
  AppBar,
  Toolbar,
  makeStyles,
  Button,
  IconButton,
  Drawer,
  Grid,
  MenuItem,
  Box,
  Container,
  Menu,
  Avatar,
  Hidden,
  SwipeableDrawer,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import React, { useState, useContext, useEffect, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import Logo from "./../../component/Logo";
import { RxCross2 } from "react-icons/rx";
import { AiFillCaretDown } from "react-icons/ai";
import { withStyles } from "@material-ui/core/styles";
import { AuthContext } from "src/context/Auth";
import { sortAddress } from "src/utils";
import toast from "react-hot-toast";
import { putAPIHandlerCall } from "src/ApiConfig/service";
import * as yup from "yup";
import { IoIosArrowDown } from "react-icons/io";
import ConfirmationDialogBox from "src/component/ConfirmationDialogBox";

const headersData = [
  {
    label: "Race",
    href: "/practice-race",
  },

  {
    label: "Garage",
    href: "/shop",
  },
  {
    label: "Mint",
    href: "/mint",
  },
  {
    label: "Learn More",
    href: "/learn-more",
  },
  {
    label: "Login",
    href: "/login",
  },
];

const useStyles = makeStyles((theme) => ({
  menubox: {
    "& ul": {
      width: "136px",
      borderRadius: "5px",
      backgroundColor: "#26252E !important",
      padding: "10px 30px 10px 10px",
      boxShadow: "0px 0px 44px 0px #00000080",

      "& li": {
        display: "flex",
        alignItems: "center",
        fontFamily: "Roboto Condensed",
        fontWeight: "400",
        lineHeight: "26px",
        fontSize: "16px",
        color: "#FFFFFF99",
        "&:hover": {
          background: "#26252e",
          color: "#fff",
        },
        "& a": {
          fontSize: "15px",
          fontFamily: "'Roboto', sans-serif",
          fontWeight: "500",
          color: "#B7B7B7",
          "& .active": {
            color: "#fff",
          },
          "&:hover": {
            color: "#fff",
          },
        },
      },
    },
  },
  menuButton: {
    fontSize: "14px",
    lineHeight: "21px",
    fontWeight: "800",
    background: "linear-gradient(180deg, #FFFFFF 0%, #ffffffcf 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    padding: "0px 9px",
    marginLeft: "3px",
    textTransform: "uppercase",
    textDecoration: "none",
    fontFamily: "Sora, sans-serif",
    "@media (max-width: 900px)": {
      padding: "15px !important",
      width: "100%",
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "flex-start",
    },
    "& .active": {
      background:
        "linear-gradient(93.34deg, #FF6F37 6.82%, #FF2676 35.9%, #B801AA 68.08%, #7101BC 101.4%)",
      textShadow: "3px 3px 3px rgb(0 0 0 / 13%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    "&:hover": {
      background:
        "linear-gradient(93.34deg, #FF6F37 6.82%, #FF2676 35.9%, #B801AA 68.08%, #7101BC 101.4%)",
      textShadow: "3px 3px 3px rgb(0 0 0 / 13%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
  },

  toolbar: {
    // height: "100%",
    display: "flex",
    padding: "8px 0px",
    justifyContent: "space-between",
    // background: "#00000080",
    // borderRadius: "50px",
    // marginTop: "20px",
    // "@media (max-width: 900px)": {
    //   paddingLeft: "75px",
    //   paddingRight: "20px",
    //   height: "100%",
    // },
  },

  drawerContainer: {
    padding: "20px 0px ",
    height: "100%",
    background: "#000",
    width: "260px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  },
  drawericon: {
    color: "#000",
    position: "absolute",
    top: "0px",
    right: "-10px",
    fontSize: "25px",
    display: "flex",
  },
  logoImg: {
    width: "130px",
    // height: '44.5px',
    // margin: " 14px 15px 11px 0px",
    objectFit: "contain",
    "@media (max-width: 500px)": {
      margin: " 11px 1px 3px 0px",
      width: "100px",
    },
  },
  menuMobile: {
    fontSize: "14px !important",
    fontWeight: "400",
    fontStyle: "normal",
    // letterSpacing: "-0.6px",
    lineHeight: "1.75",
    color: "#fff",
    width: "100%",
    // background: "rgba(255, 255, 255, 0.05)",
    // borderBottom: "1px solid #3e3e3e",
    padding: "5px 5px",
    "@media (max-width: 600px)": {
      width: "100%",
      fontSize: "14px",
      display: "flex",
      justifyContent: "center",
      // background: "rgba(255, 255, 255, 0.05)",
      padding: "7px 0px",
    },
  },

  containerHeight: {
    height: "100%",
    "& .activeButton": {
      background:
        "linear-gradient(93.34deg, #FF6F37 6.82%, #FF2676 35.9%, #B801AA 68.08%, #7101BC 101.4%)",
      textShadow: "3px 3px 3px rgb(0 0 0 / 13%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    "& .MuiMenu-paper": {
      top: "0px !important",
    },
  },
  mainHeader: {
    justifyContent: "space-between",
    padding: "0px",
  },

  drawerPaper: {
    width: "100%",
    height: "100%",
  },
  IconButtonBox: {
    position: "absolute",
    top: "0",
    right: "0",
  },
  sidebarBox: {
    maxWidth: "400px",
    width: "100%",
    padding: "10px",
    [theme.breakpoints.down("xs")]: {
      maxWidth: "355px",
    },
  },
}));

const StyledMenu = withStyles({
  paper: {
    marginTop: "20px",
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    {...props}
  />
));

export default function Header() {
  const {
    menuMobile,
    toolbar,
    menubox,
    drawerContainer,
    drawericon,
    sidebarBox,
    containerHeight,
    mainHeader,
  } = useStyles();
  const classes = useStyles();
  const history = useHistory();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open11, setOpen11] = React.useState(false);
  const [disconnect, setDisconnect] = useState(false);
  const [practiceRaceModal, setPracticeRaceModal] = useState(false);
  const [state, setState] = useState({
    mobileView: false,
    drawerOpen: false,
  });
  const { mobileView, drawerOpen } = state;

  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 1220
        ? setState((prevState) => ({ ...prevState, mobileView: true }))
        : setState((prevState) => ({ ...prevState, mobileView: false }));
    };
    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());
  }, []);

  const checkLoginCondition = true;

  const connectWalletButton = (
    <Box display="flex" style={{ gap: "15px" }}>
      <Button
        variant="contained"
        color="primary"
        onClick={() =>
          window.open(
            "https://surveys.hotjar.com/559ac8cc-2592-4cc0-8c39-5306011c943b",
            "_self"
          )
        }
      >
        {"Survey for Employee"}
      </Button>
      <Button
        variant="contained"
        color="primary"
        onClick={() =>
          window.open(
            "https://surveys.hotjar.com/bb7dc6be-109b-4080-a98d-439be84a01d5",
            "_self"
          )
        }
      >
        {"Survey for Customer"}
      </Button>
    </Box>
  );

  const femmecubatorLogo = (
    <Box>
      <Link to="/">
        <Logo className={classes.logoImg} />
      </Link>
    </Box>
  );

  const getMenuButtons = () => {
    return headersData
      .filter((item) => (item.label === "Login" ? checkLoginCondition : item))
      .map(({ label, href }) => {
        return (
          <Button
            className={`${classes.menuButton} ${
              window.location.pathname === href && "activeButton"
            }`}
            onClick={() => history.push(`${href}`)}
          >
            {label}
          </Button>
        );
      });
  };

  const displayDesktop = () => {
    return (
      <Toolbar className={toolbar}>
        {femmecubatorLogo}
        <Grid
          container
          item
          direction="row"
          justify="flex-end"
          alignItems="center"
          style={{ paddingLeft: "0px" }}
        >
          {/* {getMenuButtons()} */}
          {connectWalletButton}
        </Grid>
      </Toolbar>
    );
  };

  const displayMobile = () => {
    const handleDrawerOpen = () =>
      setState((prevState) => ({ ...prevState, drawerOpen: true }));
    const handleDrawerClose = () =>
      setState((prevState) => ({ ...prevState, drawerOpen: false }));

    return (
      <Toolbar className={mainHeader}>
        <Hidden xsDown>
          <Drawer
            {...{
              anchor: "right",
              open: drawerOpen,
              onClose: handleDrawerClose,
            }}
          >
            <div className={drawerContainer}>
              {femmecubatorLogo}
              {/* {getDrawerChoices()} */}
              {connectWalletButton}
            </div>
          </Drawer>
        </Hidden>
        <Hidden smUp>
          <SwipeableDrawer
            {...{
              anchor: "bottom",
              open: drawerOpen,
              onClose: handleDrawerClose,
            }}
            classes={{
              paper: classes.drawerPaper,
            }}
          >
            <div className={drawerContainer}>
              <div className={classes.IconButtonBox}>
                <IconButton onClick={() => handleDrawerClose()}>
                  <RxCross2 />
                </IconButton>
              </div>
              {/* {femmecubatorLogo} */}
              {/* {getDrawerChoices()} */}
              <Box mt={1}>{connectWalletButton}</Box>
            </div>
          </SwipeableDrawer>
        </Hidden>

        <div>{femmecubatorLogo}</div>
        <Grid container>
          <Grid item xs={6}></Grid>
          <Grid item xs={4}>
            <Box className={drawericon}>
              <Box
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  display: "none",
                }}
                // onClick={handleClick}
                mr={1}
              >
                <Avatar src="images/mgpro.png" />
                <AiFillCaretDown style={{ color: "#fff", fontSize: "15px" }} />
              </Box>
              <IconButton
                {...{
                  edge: "start",
                  color: "inherit",
                  "aria-label": "menu",
                  "aria-haspopup": "true",
                  onClick: handleDrawerOpen,
                }}
              >
                <MenuIcon
                  width="60px"
                  height="60px"
                  style={{ color: "#ff2676", fontSize: "30px" }}
                />
              </IconButton>
            </Box>
          </Grid>
        </Grid>
      </Toolbar>
    );
  };

  const getDrawerChoices = () => {
    return headersData
      .filter((item) => (item.label === "Login" ? checkLoginCondition : item))
      .map(({ label, href }) => {
        return (
          <Button
            // {...{
            //   key: label,
            //   color: "inherit",
            //   to: href,
            //   component: Link,
            // }}
            onClick={() => history.push(`${href}`)}
          >
            <MenuItem className={menuMobile}>{label}</MenuItem>
          </Button>
        );
      });
  };

  return (
    <AppBar
      position={window.location.pathname !== "/" ? "relative" : "absolute"}
      elevation={0}
      style={{ backgroundColor: "#fff", border: "none" }}
    >
      <Container maxWidth="lg" className={containerHeight}>
        {mobileView ? displayMobile() : displayDesktop()}
        <StyledMenu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          className={menubox}
          onClose={(e) => setAnchorEl(null)}
        >
          <MenuItem onClick={() => history.push("/profile")}>
            <img
              src="/images/profileUser.svg"
              alt="User"
              width="20px"
              height="20px"
            />
            &nbsp; Profile
          </MenuItem>
          <MenuItem
            onClick={() => {
              setDisconnect(true);
              setAnchorEl(null);
            }}
          >
            <img
              src="/images/disconnect.svg"
              alt="Disconnect"
              width="20px"
              height="20px"
            />
            &nbsp; Disconnect
          </MenuItem>
        </StyledMenu>
      </Container>
      {practiceRaceModal && (
        <ConfirmationDialogBox
          openModal={practiceRaceModal}
          handleClose={() => setPracticeRaceModal(false)}
        />
      )}
    </AppBar>
  );
}
